import {
  withCompInfo,
  withStateRefsValues,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations/siteAssets';
import type { ResponsiveContainerProps } from '@wix/thunderbolt-components';
import type { IHamburgerMenuRootProps } from '../HamburgerMenuRoot.props';
import type { IHamburgerMenuRootDefinition } from '../documentManagement/HamburgerMenuRoot.definition';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export type IHamburgerMenuRootCarmiProps = {
  containerProps?: ResponsiveContainerProps;
  containerRootClassName?: string;
};

export const props = withCompInfo<
  IHamburgerMenuRootProps,
  IHamburgerMenuRootDefinition,
  IHamburgerMenuRootCarmiProps
>()(
  ['compData', 'hasResponsiveLayout', 'compMeshProps', 'experiments'],
  ({ compData, hasResponsiveLayout, experiments }, carmiData) => {
    const isClassNameToRootEnabled = isExperimentOpen(
      experiments,
      'specs.thunderbolt.isClassNameToRootEnabledNext',
    );

    return {
      ...compData,
      ...carmiData,
      hasResponsiveLayout,
      isMenuOpen: undefined,
      shouldFocus: true,
      isClassNameToRootEnabled,
    };
  },
);

export const stateRefs = withStateRefsValues(['editorType']);

export default createComponentMapperModel({ props, stateRefs });
